// Main App component

import React, { useState } from 'react';
import PairingScreen from './components/PairingScreen/PairingScreen';
import VRExperience from './components/VRExperience/VRExperience';
import { useWebSocket } from './hooks/useWebSocket';
import { usePairingToken } from './hooks/usePairingToken';
import './App.css';

function App() {
  const [isPaired, setIsPaired] = useState(false);
  const { token, isValid } = usePairingToken();

  // Manage WebSocket at App level to prevent duplicate connections
  const wsState = useWebSocket(isValid ? token : null);

  return (
    <div className="App">
      {!isPaired ? (
        <PairingScreen
          onPairingComplete={() => setIsPaired(true)}
          wsState={wsState}
        />
      ) : (
        <VRExperience wsState={wsState} />
      )}
    </div>
  );
}

export default App;
